module.exports = __webpack_public_path__ + "static/media/Capital-Markets.ce41aa44.jpg";